import axios from 'axios';

const API_BASE = '/api/integrations';

export const getIntegrationStatus = async (provider) => {
  try {
    const response = await axios.get(`${API_BASE}/${provider}/status`);
    return response.data;
  } catch (error) {
    console.error('Error getting integration status:', error);
    throw error;
  }
};

export const testConnection = async (provider, credentials) => {
  try {
    const response = await axios.post(`${API_BASE}/${provider}/test`, {
      credentials
    });
    return response.data;
  } catch (error) {
    console.error('Error testing connection:', error);
    throw error;
  }
};

export const configureIntegration = async (provider, config) => {
  try {
    const response = await axios.post(`${API_BASE}/${provider}/configure`, {
      config
    });
    return response.data;
  } catch (error) {
    console.error('Error configuring integration:', error);
    throw error;
  }
};

export const syncFromExternal = async (provider, options = {}) => {
  try {
    const response = await axios.post(`${API_BASE}/${provider}/sync`, options);
    return response.data;
  } catch (error) {
    console.error('Error syncing from external:', error);
    throw error;
  }
};

export const getUnmappedRecords = async (provider, filters = {}) => {
  try {
    const response = await axios.get(`${API_BASE}/${provider}/unmapped`, {
      params: filters
    });
    return response.data;
  } catch (error) {
    console.error('Error getting unmapped records:', error);
    throw error;
  }
};

export const autoMapRecords = async (provider, rules = {}) => {
  try {
    const response = await axios.post(`${API_BASE}/${provider}/auto-map`, {
      rules
    });
    return response.data;
  } catch (error) {
    console.error('Error auto-mapping records:', error);
    throw error;
  }
};

export const bulkMapRecords = async (provider, mappingPairs) => {
  try {
    const response = await axios.post(`${API_BASE}/${provider}/bulk-map`, {
      mappingPairs
    });
    return response.data;
  } catch (error) {
    console.error('Error bulk mapping:', error);
    throw error;
  }
};
// Add to your integrations API file
export const getAvailableProviders = async () => {
    try {
      const response = await axios.get(`${API_BASE}/providers/available`);
      return response.data;
      
    } catch (error) {
      console.error('Error getting providers:', error);
      // Return default list if API fails
      return [
        { id: 'tally', name: 'Tally ERP', icon: '📊', description: 'Indian accounting software' },
        { id: 'quickbooks', name: 'QuickBooks', icon: '💼', description: 'International accounting' },
        { id: 'zoho', name: 'Zoho Books', icon: '📈', description: 'Cloud accounting suite' },
        { id: 'sap', name: 'SAP Business One', icon: '🏢', description: 'Enterprise ERP system' },
        { id: 'xero', name: 'Xero', icon: '🌐', description: 'Cloud-based accounting' },
        { id: 'freshbooks', name: 'FreshBooks', icon: '📖', description: 'Invoicing & accounting' },
        { id: 'sage', name: 'Sage Intacct', icon: '🧾', description: 'Advanced financial management' },
        { id: 'netsuite', name: 'Oracle NetSuite', icon: '☁️', description: 'Cloud ERP solution' }
      ];
    }
  };